import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TaxonomyE2EType, TaxonomyFunctionItem, TaxonomySubProcessType } from '../../../slices/allTaxonomy/taxonomyTypes';

interface TaxonomyState {
  selectedE2E: TaxonomyE2EType | null;
  selectedTaxonomy: TaxonomyFunctionItem | null;
  selectedSubprocess: TaxonomySubProcessType | null;
  loading: boolean;
}

const initialState: TaxonomyState = {
  selectedE2E: null,
  selectedTaxonomy: null,
  selectedSubprocess: null,
  loading: false,
};

const taxonomySlice = createSlice({
  name: 'taxonomy',
  initialState,
  reducers: {
    setSelectedE2E(state, action: PayloadAction<TaxonomyE2EType | null>) {
      state.selectedE2E = action.payload;
    },
    setSelectedTaxonomy(state, action: PayloadAction<TaxonomyFunctionItem | null>) {
      state.selectedTaxonomy = action.payload;
    },
    setSelectedSubprocess(state, action: PayloadAction<TaxonomySubProcessType | null>) {
      state.selectedSubprocess = action.payload;
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    resetTaxonomyState(state) {
      state.selectedE2E = null;
      state.selectedTaxonomy = null;
      state.selectedSubprocess = null;
      state.loading = false;
    },
  },
});

export const {
  setSelectedE2E,
  setSelectedTaxonomy,
  setSelectedSubprocess,
  setLoading,
  resetTaxonomyState,
} = taxonomySlice.actions;

export default taxonomySlice.reducer;
